import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { addFollowButton } from '@/js/lib/ui/follow-button';
import SocialShare from '@/js/components/common/ui/share.vue';
import PhotoViewer from '@/js/components/www.iichi.com/organisms/PhotoViewer.vue';
import EventLikeButton from '@/js/components/www.iichi.com/pages/event/EventLikeButton.vue';

interface Picture {
  path: string;
  alt: string;
  width: number;
  height: number;
  comment: string;
}

document.addEventListener('DOMContentLoaded', () => {
  if ('customElements' in window) {
    const photoViewerEl = document.querySelector('photo-viewer') as HTMLElement;
    createApp({
      render: () =>
        h(PhotoViewer, {
          pictures: JSON.parse(photoViewerEl.dataset.pictures!) as Picture[],
        }),
    }).mount(photoViewerEl);
  }

  const eventLikeButtonEl = document.querySelector('event-like-button') as HTMLElement;
  createApp({
    render: () =>
      h(EventLikeButton, {
        eventId: Number(eventLikeButtonEl.dataset.eventId),
        slug: eventLikeButtonEl.dataset.slug!,
      }),
  }).mount(eventLikeButtonEl);

  const socialShareEl = document.querySelector('social-share') as HTMLElement;
  createApp({
    render: () =>
      h(SocialShare, {
        title: socialShareEl.dataset.title,
        url: socialShareEl.dataset.url,
      }),
  }).mount(socialShareEl);

  addFollowButton();
});
